const copyButton = document.getElementById("copy-button");
const bookmarkCard = document.getElementById("bookmark-card");
const bookmarkHint = document.getElementById("bookmark-hint");
const wechatId = document.getElementById("wechat-id");
const switchPills = Array.from(document.querySelectorAll(".switch-pill"));
const planLabel = document.getElementById("plan-label");
const planPrice = document.getElementById("plan-price");
const planBadge = document.getElementById("plan-badge");
const planSubtitle = document.getElementById("plan-subtitle");
const planCta = document.getElementById("plan-cta");
const planFeatures = document.getElementById("plan-features");
const purchaseUrl = "https://fe.dtyuedan.cn/shop/ddm";
const planData = {
    basic: {
        label: "\u6708\u4ED8",
        price: "\xa5180",
        badge: "\u6708\u4ED8",
        subtitle: "\u76F4\u51B2\u81EA\u5DF1\u7684\u8D26\u53F7\uFF0C\u65E0\u9700\u63D0\u4F9B\u8D26\u53F7\u5BC6\u7801",
        cta: "\u7ACB\u5373\u8D2D\u4E70\u6708\u4ED8",
        features: [
            {
                icon: "\u2197",
                title: "\u4EF7\u683C\u66F4\u7701\uFF0C\u6548\u7387\u66F4\u9AD8",
                text: "\u5168\u7A0B\u4F7F\u7528\u6B63\u89C4\u5F00\u901A\u65B9\u5F0F\u5904\u7406\u8BA2\u5355\u3002"
            },
            {
                icon: "\u2726",
                title: "\u7701\u53BB\u652F\u4ED8\u70E6\u607C\uFF0C\u9002\u5408\u56FD\u5185\u7528\u6237",
                text: "\u4E0D\u7528\u62C5\u5FC3\u7ED1\u5361\u5931\u8D25\u3001\u4ED8\u6B3E\u4E0D\u8FC7\u7B49\u95EE\u9898\u3002"
            },
            {
                icon: "\u2727",
                title: "\u65E0\u9700\u63D0\u4F9B\u8D26\u53F7\u5BC6\u7801",
                text: "\u51CF\u5C11\u4FE1\u606F\u66B4\u9732\u98CE\u9669\uFF0C\u6D41\u7A0B\u7B80\u5355\uFF0C\u4F7F\u7528\u5B89\u5FC3"
            },
            {
                icon: "\u223F",
                title: "\u652F\u6301\u652F\u4ED8\u5B9D / \u5FAE\u4FE1 "
            },
            {
                icon: "\u25EB",
                title: "\u5F02\u5E38\u95EE\u9898\u53EF\u8054\u7CFB\u4EBA\u5DE5\u5BA2\u670D"
            }
        ]
    },
    insured: {
        label: "\u6210\u54C1\u53F7",
        price: "\xa5180",
        badge: "\u63A8\u8350",
        subtitle: "\u5145\u503C\u597D\u4F1A\u5458\u7684 SuperGrok \u8D26\u6237",
        cta: "\u7ACB\u5373\u8D2D\u4E70\u6210\u54C1\u53F7",
        features: [
            {
                icon: "\u2197",
                title: "\u4E0D\u60F3\u6298\u817E\u5B98\u65B9\u652F\u4ED8\u548C\u6CE8\u518C\u6D41\u7A0B\u7684",
                text: "\u63D0\u4F9B\u8D26\u53F7\u3001\u5BC6\u7801\u3001\u90AE\u7BB1\u5BC6\u7801\uFF0C\u76F4\u63A5\u767B\u5F55\u4F7F\u7528\u3002"
            },
            {
                icon: "\u2726",
                title: "\u76F4\u63A5\u7528\u3001\u56FE\u7701\u4E8B\u7684\u7528\u6237\u9996\u9009",
                text: "\u65E0\u9700\u81EA\u5DF1\u6CE8\u518C\u3001\u5145\u503C\uFF0C\u76F4\u63A5\u767B\u5F55\u4F7F\u7528\u3002"
            },
            {
                icon: "\u223F",
                title: "\u652F\u6301\u8865\u5355\u6216\u9000\u6B3E",
                text: "\u6839\u636E\u5B9E\u9645\u5F02\u5E38\u60C5\u51B5\u6309\u9875\u9762\u89C4\u5219\u6267\u884C\u552E\u540E\u3002"
            },
            {
                icon: "\u2727",
                title: "\u76F4\u63A5\u7528\u3001\u56FE\u7701\u4E8B\u7684\u7528\u6237\u9996\u9009"
            },
            {
                icon: "\u25EB",
                title: "\u964D\u4F4E\u95E8\u69DB\uFF0C\u9002\u5408\u65B0\u624B\u5165\u95E8"
            }
        ]
    }
};
function renderFeatures(features) {
    if (!planFeatures) return;
    planFeatures.innerHTML = features.map(({ icon, title, text })=>{
        const description = text ? `<p>${text}</p>` : "";
        return `
        <li>
          <span class="feature-icon">${icon}</span>
          <div>
            <strong>${title}</strong>
            ${description}
          </div>
        </li>
      `;
    }).join("");
}
function setPlan(planName) {
    const plan = planData[planName];
    if (!plan || !planLabel || !planPrice || !planBadge || !planSubtitle || !planCta) return;
    planLabel.textContent = plan.label;
    planPrice.textContent = plan.price;
    planBadge.textContent = plan.badge;
    planSubtitle.textContent = plan.subtitle;
    planCta.textContent = plan.cta;
    planCta.href = purchaseUrl;
    planCta.target = "_blank";
    planCta.rel = "noopener noreferrer";
    renderFeatures(plan.features);
    switchPills.forEach((pill)=>{
        const isActive = pill.dataset.plan === planName;
        pill.classList.toggle("is-active", isActive);
        pill.setAttribute("aria-selected", String(isActive));
    });
}
if (switchPills.length > 0) {
    switchPills.forEach((pill)=>{
        pill.addEventListener("click", ()=>{
            setPlan(pill.dataset.plan);
        });
    });
    setPlan("basic");
}
if (copyButton && wechatId) copyButton.addEventListener("click", async ()=>{
    const value = wechatId.textContent.trim();
    try {
        await navigator.clipboard.writeText(value);
        copyButton.textContent = "\u5DF2\u590D\u5236";
        window.setTimeout(()=>{
            copyButton.textContent = "\u590D\u5236\u5FAE\u4FE1\u53F7";
        }, 1600);
    } catch  {
        copyButton.textContent = "\u590D\u5236\u5931\u8D25";
        window.setTimeout(()=>{
            copyButton.textContent = "\u590D\u5236\u5FAE\u4FE1\u53F7";
        }, 1600);
    }
});
function getBookmarkShortcut() {
    const platform = navigator.platform.toLowerCase();
    if (platform.includes("mac")) return "Cmd + D";
    return "Ctrl + D";
}
function setBookmarkHint(message) {
    if (!bookmarkHint) return;
    bookmarkHint.textContent = message;
}
async function handleBookmarkAction() {
    const currentUrl = window.location.href;
    const shortcut = getBookmarkShortcut();
    try {
        if (window.external && typeof window.external.AddFavorite === "function") {
            window.external.AddFavorite(currentUrl, document.title);
            setBookmarkHint("\u5DF2\u8C03\u7528\u6D4F\u89C8\u5668\u6536\u85CF\u63A5\u53E3\uFF0C\u53EF\u5728\u4E66\u7B7E\u680F\u91CC\u67E5\u770B\u3002");
            bookmarkCard?.classList.add("is-saved");
            return;
        }
        if (window.sidebar && typeof window.sidebar.addPanel === "function") {
            window.sidebar.addPanel(document.title, currentUrl, "");
            setBookmarkHint("\u5DF2\u8C03\u7528\u6D4F\u89C8\u5668\u6536\u85CF\u63A5\u53E3\uFF0C\u53EF\u5728\u4E66\u7B7E\u680F\u91CC\u67E5\u770B\u3002");
            bookmarkCard?.classList.add("is-saved");
            return;
        }
        await navigator.clipboard.writeText(currentUrl);
        setBookmarkHint(`\u{6D4F}\u{89C8}\u{5668}\u{9650}\u{5236}\u{65E0}\u{6CD5}\u{76F4}\u{63A5}\u{6536}\u{85CF}\u{FF0C}\u{94FE}\u{63A5}\u{5DF2}\u{590D}\u{5236}\u{FF0C}\u{8BF7}\u{6309} ${shortcut} \u{5B8C}\u{6210}\u{6536}\u{85CF}\u{3002}`);
        bookmarkCard?.classList.add("is-saved");
    } catch  {
        setBookmarkHint(`\u{8BF7}\u{6309} ${shortcut} \u{6536}\u{85CF}\u{5F53}\u{524D}\u{9875}\u{3002}`);
    }
}
if (bookmarkCard) {
    bookmarkCard.addEventListener("click", ()=>{
        handleBookmarkAction();
    });
    bookmarkCard.addEventListener("keydown", (event)=>{
        if (event.key !== "Enter" && event.key !== " ") return;
        event.preventDefault();
        handleBookmarkAction();
    });
}

//# sourceMappingURL=supergrok.9116cc27.js.map
